import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { SliderWithLabels } from '../../../components/ui/SliderWithLabels'

interface Props {
  className?: string
  state?: StateType
}

export const YearsSlider: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const { yearsExtent, selectedYear, setSelectedYear } = state.ScatterplotState

    return (
      <SliderWithLabels
        className={`${className}`}
        min={yearsExtent[0]}
        max={yearsExtent[1]}
        step={1}
        value={selectedYear}
        showTooltip
        onChange={(value) => setSelectedYear(value)}
      />
    )
  })
)
